var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGroupObjectsIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 34,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h36v34H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 4)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.852 3.852)",
  stroke: "#545454"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.961,
  cy: 5.961,
  r: 5.461
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#999",
  fillRule: "nonzero",
  x: 7.837,
  y: 7.837,
  width: 10.922,
  height: 10.922,
  rx: 1
})), /*#__PURE__*/React.createElement("rect", {
  stroke: "#999",
  x: 1.463,
  y: 1.463,
  width: 23.074,
  height: 23.074,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#545454",
  fillRule: "nonzero",
  d: "M23.111 0H26v2.889h-2.889zm0 23.111H26V26h-2.889zM0 23.111h2.889V26H0zM0 0h2.889v2.889H0z"
})))));
export default SvgGroupObjectsIcon;